import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const RTL_LANGUAGES = ['he', 'yi', 'ar'];

function applyDirection(lng: string) {
  const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'he', 'yi'],
    // Only honor an explicit user choice (settings page / cached choice).
    // Never auto-switch from the browser's language — the UI would flip to RTL
    // for users whose browser reports Hebrew even though they use the app in English.
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      // Fresh key: the default 'i18nextLng' may hold a stale auto-detected value
      lookupLocalStorage: 'appLanguage',
    },
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

applyDirection(i18n.language || 'en');
i18n.on('languageChanged', applyDirection);

export default i18n;